'use strict';

function intersection(arr1, arr2) {
  return arr1.filter(function(value, index) {
    return (
      arr2.indexOf(value) > -1 &&
      arr1.indexOf(value) === index /* skips duplicates */
    );
  });
}

module.exports = intersection;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/node_modules/algoliasearch-helper/src/functions/intersection.js
// module id = 118
// module chunks = 0